import { Container, Row, Col } from './styles';

import BarChart from "./components/BarChart";
import LineChart from "./components/LineChart";
import RadarChart from "./components/RadarChart";
import StreamChart from "./components/StreamChart";
import PieChart from "./components/PieChart";
import BumpChart from "./components/BumpChart";
import ScatterChart from "./components/ScatterChart";

import { bar, line, radar, stream, pie, bump, scatter, aoe} from "./data";

const App = () => (
  <Container fluid>
        <h2>AoE2: Unit HP - DPS</h2>

        <p>
        <b>X axis (attack per second) formula</b><br/>
<i>(Attack + (ChargeEvent * MaxCharge / RechargeDuration || 1)) * AccuracyPercent/100 / (ReloadTime + AttackDelaySeconds)</i>
        </p>

        <p>
        <b>Y axis (health indication) formula</b><br/>
        <i>Math.sqrt(maxArmor) * HP</i>
        </p>

    <Row debug>
      <Col debug>
        <ScatterChart data={aoe}/>
      </Col>
{/*       <Col debug> */}
{/*         <LineChart data={line}/> */}
{/*       </Col> */}
{/*       <Col debug>  */}
{/*         <RadarChart data={radar}/> */}
{/*       </Col> */}
    </Row>

    <p>
    <a target="_blank" href="https://veste-software.com/">https://veste-software.com/</a> <br/>
    We create websites specializing in data visualizations of any kind. We'd love to discuss your project!
    </p>
{/*     <Row debug> */}
{/*       <Col debug>   */}
{/*         <StreamChart data={stream}/> */}
{/*       </Col> */}
{/*       <Col debug> */}
{/*         <PieChart data={pie}/> */}
{/*       </Col> */}
{/*       <Col debug>  */}
{/*         <BumpChart data={bump}/> */}
{/*       </Col> */}
{/*     </Row> */}
  </Container>
);

export default App;
